import { useState } from 'react'
import { useHistory } from 'react-router'
import renderImage from '../../../source/importImg'
import KitSelectStyle from './KitSelectionHeader.module.css'
import { connect } from 'react-redux'
import { languageWords } from '../../../utils/langaugeSupport'
import { setLanguageSelect } from '../../../redux/actions'

function KitSelectionHeader(props) {
    const {
        setShowLanguagePopup,
        setFilteredResults,
        filteredResults,
        supportedDevice,
    } = props

    const history = useHistory()
    // const [isHelp, setHelp] = useState(false)
    const [search, setSearch] = useState('')
    const [suggestions, setSuggestions] = useState([])

    const languageName = props.device.language

    // const handleHelpBtn = (e) => {
    //     if (isHelp == true) {
    //         setHelp(false)
    //     } else {
    //         setHelp(true)
    //     }
    // }

    // const gobackUrl = () => {
    //     sessionStorage.setItem('slideDirection', true)
    //     history.push('/kitSelection')
    // }

    const handleSearch = (e) => {
        const value = e.target.value

        setSearch(e.target.value)
        if (!e.target.value.trim()) {
            // setActiveTab(1)
            setFilteredResults({})
        }
        if (value) {
            const allSuggestions = [...supportedDevice]
            const filteredSuggestions = allSuggestions.filter((suggestion) =>
                suggestion.name.toLowerCase().includes(value.toLowerCase())
            )
            console.log(filteredSuggestions)
            setSuggestions(filteredSuggestions)
        } else {
            setSuggestions([])
        }
    }
    const handleSuggestion = (suggestion) => {
        setSearch(suggestion.name)
        setFilteredResults(suggestion)
        setSuggestions([])
    }

    return (
        <div className={KitSelectStyle.Connect_Header}>
            <div className=""></div>

            <p className={KitSelectStyle.text}>
                {languageWords[languageName]?.SelectDevice || 'Select your Kit'}
            </p>
            <div>
                <div>
                    <div className="header_button">
                        <img
                            className={KitSelectStyle.helpBtn}
                            src={renderImage('activeAdvanceSetting')}
                            onClick={() => setShowLanguagePopup(true)}
                            // style={{ right: '30%' }}
                        ></img>
                        <span
                            className="tooltiptext"
                            style={{
                                // top: '13vh',
                                zIndex: '1',
                            }}
                        >
                            {' '}
                            <p>Language</p>
                        </span>
                    </div>
                    <div className={KitSelectStyle.searchInput}>
                        <input
                            type="text"
                            name="search"
                            value={search}
                            onChange={handleSearch}
                        />
                        {Object.keys(filteredResults).length > 0 ? (
                            <div
                                className={KitSelectStyle.binIcon}
                                onClick={() => {
                                    setSearch('')
                                    // setActiveTab(1)
                                    setFilteredResults({})
                                }}
                            >
                                <img
                                    src="https://cdn-icons-png.flaticon.com/128/2976/2976286.png"
                                    alt="bin"
                                />
                                {/* <img
                                                    src="https://cdn-icons-png.flaticon.com/128/3395/3395538.png"
                                                    alt="search"
                                                /> */}
                                {/* </div> */}
                            </div>
                        ) : (
                            <div className={KitSelectStyle.searchIcon}>
                                <img
                                    src={renderImage('searchIcon')}
                                    alt="search"
                                />
                            </div>
                        )}
                        {suggestions.length > 0 && (
                            <ul className={KitSelectStyle.suggestions}>
                                {suggestions.map((suggestion, index) => (
                                    <li
                                        key={index}
                                        onClick={() =>
                                            handleSuggestion(suggestion)
                                        }
                                    >
                                        <img
                                            width={'24px'}
                                            src={renderImage(suggestion.src)}
                                            alt={suggestion.title}
                                        />
                                        {/* <span
                                                            className={
                                                                KitSelectStyle.suggestion_title
                                                            }
                                                        >
                                                            {suggestion.title}
                                                        </span>{' '}
                                                        / */}
                                        <span
                                            className={
                                                KitSelectStyle.suggestion_name
                                            }
                                        >
                                            {suggestion.name}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return state
}
const mapDispatchToProps = (dispatch) => {
    return {
        setLanguageSelect: (data) => {
            dispatch(setLanguageSelect(data))
        },
        setSocket: (data) => {
            dispatch({ type: 'SOCKET', payload: data })
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(KitSelectionHeader)
